// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"585":"4f110cf4","832":"df98a161"}[chunkId] + ".chunk.js";
};